import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
    computed: {
        ...mapGetters('tag', ['tagList']),

        tagLoading() {
            return this.onLoading('fetch-tag');
        },
    },

    methods: {
        ...mapActions('tag', ['findTags', 'getTag', 'getTagListIfNecessary']),

        refreshTagList: _.debounce(function(query) {
            this.getTagListIfNecessary({ query: query });
        }, 500),
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/tags.js